import { buildEyeButtonOptions } from "Components/optionForm";
import { set } from "lodash/fp";
export const changePasswordMode = (field, gridRef, targetMode) => {
    var _a, _b, _c, _d;
    const instance = (_a = gridRef.current) === null || _a === void 0 ? void 0 : _a.instance;
    if (!((_c = (_b = instance === null || instance === void 0 ? void 0 : instance.getController("editing")) === null || _b === void 0 ? void 0 : _b.getEditForm()) === null || _c === void 0 ? void 0 : _c.itemOption))
        return;
    const prevEditorOptions = ((_d = instance.getController("editing").getEditForm().itemOption(field)) === null || _d === void 0 ? void 0 : _d.editorOptions) || {};
    const newMode = targetMode || (prevEditorOptions.mode === "password" ? "text" : "password");
    let newEditorOptions = set("mode", newMode, prevEditorOptions);
    newEditorOptions = set("buttons[0].options.icon", newMode === "password" ? "eye" : "eye-slash", newEditorOptions);
    instance
        .getController("editing")
        .getEditForm()
        .itemOption(field, "editorOptions", newEditorOptions);
};
export default (field, gridRef) => ({
    showClearButton: false,
    mode: "password",
    buttons: [
        {
            location: "after",
            name: "eye-button",
            options: buildEyeButtonOptions("password", () => {
                changePasswordMode(field, gridRef);
            })
        }
    ]
});
